export default __webpack_public_path__ + "static/media/centralized.cb742ac4.png";